var map = {
	"./MapThumb_Acropolis.webp": "6b52",
	"./MapThumb_Arabia.webp": "422f",
	"./MapThumb_BabylonianBasin.webp": "fbbb",
	"./MapThumb_BanditCanyon.webp": "1fbc",
	"./MapThumb_BanditHideout.webp": "30b2",
	"./MapThumb_BigIsland.webp": "02e0",
	"./MapThumb_BlackForest.webp": "9fae",
	"./MapThumb_CampLagoon.webp": "749b",
	"./MapThumb_Coastal.webp": "4d9b",
	"./MapThumb_DuelingIslands.webp": "31ea",
	"./MapThumb_EqualFooting.webp": "f560",
	"./MapThumb_FairFight.webp": "ab1f",
	"./MapThumb_FertileValley.webp": "daf9",
	"./MapThumb_FourLakes.webp": "9aec",
	"./MapThumb_GhostLake.webp": "b5c1",
	"./MapThumb_GoldRush.webp": "5271",
	"./MapThumb_Grasslands.webp": "a8eb",
	"./MapThumb_GreatLake.webp": "8fbb",
	"./MapThumb_Highlands.webp": "5e0f3",
	"./MapThumb_HillFort.webp": "ff59",
	"./MapThumb_KingOfTheHill.webp": "e6c7",
	"./MapThumb_LowlandGroves.webp": "7784",
	"./MapThumb_Marshlands.webp": "664a",
	"./MapThumb_Maze.webp": "e128",
	"./MapThumb_MountainCrossing.webp": "4c81",
	"./MapThumb_NewInland.webp": "a881",
	"./MapThumb_NoMansLand.webp": "9e48",
	"./MapThumb_Oasis.webp": "853b",
	"./MapThumb_Overpass.webp": "ee46",
	"./MapThumb_PersianQuarries.webp": "6d48",
	"./MapThumb_ResourceWar.webp": "6239",
	"./MapThumb_RiverNile.webp": "677c",
	"./MapThumb_Savannah.webp": "275d",
	"./MapThumb_ShelteredPass.webp": "5525",
	"./MapThumb_SpiralValley.webp": "ae2a",
	"./MapThumb_SwampPass.webp": "8cd4",
	"./MapThumb_TeutoburgForest.webp": "40a5",
	"./MapThumb_TreasureIsland.webp": "6bf87",
	"./MapThumb_Tundra.webp": "799b",
	"./MapThumb_WateringHole.webp": "bd08",
	"./MapThumb_Wetlands.webp": "ac75",
	"./MapThumb_Wildwoods.webp": "901a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c50f";